import type { ReactNode } from 'react';
import { useContext } from 'react';
import { CloseIconButton } from '../IconButton';
import { OnCloseContext } from './OnCloseContext';
import styles from './styles.module.css';

export interface ModalHeaderProps {
  children: NonNullable<ReactNode>;
  left?: ReactNode;
  right?: ReactNode;
}

export function ModalHeader({ left, right, children }: ModalHeaderProps): ReactNode {
  const onClose = useContext(OnCloseContext);

  return (
    <div className={styles.Header}>
      {left && <div className={styles.Left}>{left}</div>}
      <div className={left ? undefined : styles.Title}>{children}</div>
      {right !== undefined ? (
        right
      ) : (
        <div className={styles.Right}>
          <CloseIconButton onClick={onClose} />
        </div>
      )}
    </div>
  );
}
